// extracted by mini-css-extract-plugin
export default {"wrapper":"twoPlayersIntroduction_wrapper__b-ksE","button":"twoPlayersIntroduction_button__JFspT"};